import { useState } from "react";
import { db } from "../firebase";
import {
  doc,
  updateDoc,
  increment,
} from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { decideWinners } from "../services/winnerService";

function DecideWinnerScreen() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const {
    tournamentId,
    participants,
    tournamentData,
    collectionType,
  } = state || {};

  // 🔥 CONFIG (collection wise behavior)
  const config = {
    cs_tournaments: { multi: false, kills: false },
    br_tournaments: { multi: false, kills: true },
    br_s_tournaments: { multi: true, kills: true },
    lw_tournaments: { multi: false, kills: true },
    onetap_tournaments: { multi: false, kills: false },
  };

  const { multi, kills } = config[collectionType] || {};

  const [selected, setSelected] = useState({});
  const [teamKills, setTeamKills] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔥 GROUP TEAMS
  const teams = {};
  participants?.forEach((p) => {
    if (!teams[p.team]) teams[p.team] = [];
    teams[p.team].push(p);
  });

  // 🔥 SELECT TEAM
  const toggleTeam = (team) => {
    if (!multi) {
      setSelected({ [team]: true });
    } else {
      setSelected((prev) => ({
        ...prev,
        [team]: !prev[team],
      }));
    }
  };

  // 🔥 SAVE WINNER
const saveWinner = async () => {
  await decideWinners({
    tournamentId,
    participants,
    tournamentData,
    collectionType,
    selectedTeams: selected,
    teamKills,
  });

  alert("Done ✅");
  navigate(-1);
};

  return (
    <div style={container}>
      <h2>🏆 Select Winner</h2>

      {Object.keys(teams).map((team) => (
        <div key={team} style={card}>
          <div style={row}>
            <input
              type={multi ? "checkbox" : "radio"}
              name="winner"
              checked={selected[team] || false}
              onChange={() => toggleTeam(team)}
            />

            <span>Team {team}</span>
          </div>

          {/* 🔥 KILLS INPUT */}
          {kills && selected[team] && (
            <input
              type="number"
              placeholder="Kills"
              value={teamKills[team] || ""}
              onChange={(e) =>
                setTeamKills((prev) => ({
                  ...prev,
                  [team]: e.target.value,
                }))
              }
            />
          )}

          {/* 👥 MEMBERS */}
          <div style={{ fontSize: 12, marginTop: 5 }}>
            {teams[team].map((m) => m.name).join(", ")}
          </div>
        </div>
      ))}

      <button onClick={saveWinner} style={btn}>
        {loading ? "Saving..." : "Save Winner"}
      </button>
    </div>
  );
}

/* 🔥 UI */

const container = {
  padding: 20,
  color: "white",
};

const card = {
  background: "#1E2235",
  padding: 12,
  borderRadius: 10,
  marginBottom: 10,
};

const row = {
  display: "flex",
  gap: 10,
  alignItems: "center",
};

const btn = {
  marginTop: 20,
  padding: 12,
  background: "#2563EB",
  border: "none",
  borderRadius: 10,
  color: "#fff",
  cursor: "pointer",
};

export default DecideWinnerScreen;